import app from "../../main";

export default {
  setLocale(state, payload) {
    app.$i18n.locale = payload;
    localStorage.setItem("locale", payload);
    state.locale = payload;
  },
  selectCompany(state, payload) {
    state.activeCompany = payload;
    localStorage.setItem("activeCompany", JSON.stringify(payload));
  },
  setCompanyList(state, payload) {
    state.companyList = payload;

    if (!state.activeCompany) {
      state.activeCompany = state.companyList[0];
    } else {
      let foundActiveCompany = false;
      state.companyList.forEach((scL) => {
        if (scL.id === state.activeCompany.id) {
          foundActiveCompany = true;
          state.activeCompany = scL;
        }
      });
      if (!foundActiveCompany) {
        state.activeCompany = state.companyList[0];
      }

      // let i = 0;

      // while (i < state.companyList.length && !( state.companyList[i].id ===  state.activeCompany.id)) {
      //     ++i;
      // }

      // if(i >= state.companyList.length) {
      //     state.activeCompany = state.companyList[0];
      // }
    }
  },
};
